module.exports = "/5/3-mang-hai-chieu/index.html.20eabc78d6c5ccd506f5e0a0d9bc1987.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30085.md
 ** module id = 555
 ** module chunks = 0
 **/